// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__QG2wW","overflowing":"ReadFullNote_overflowing__XahST"};